// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.

export const environment = {
  production: false,
  apiUrl: '/api/Public/api',
  apiServerUrl: 'https://clavewinds.shop/api/Public/api',
  mediaUrl: 'https://clavewinds.shop/api/',
  siteUrl: '',
  googleClientId: '672622805765-q4rerk03h4t4jc0jejd3bic3ph7v05s9.apps.googleusercontent.com',
  facebookAppId: '299947848303007',
  googleTagManagerId: '',
  googleAnalyticsMeasurementId: '',
  analyticsEnabled: false
};
